import React, { Fragment, useEffect, useState, useMemo, useCallback } from "react";
import { Table, Button, Card, CardBody, Col, Container, CardHeader, Nav, NavItem, NavLink, Row, Modal, ModalHeader, Form, ModalBody, Label, Input, FormFeedback, Spinner, ListGroup, ListGroupItem, UncontrolledButtonDropdown, UncontrolledDropdown, DropdownItem, DropdownMenu, DropdownToggle, ButtonGroup } from "reactstrap";
import SimpleBar from "simplebar-react";
import moment from "moment";
import "moment-timezone";
import { Link } from "react-router-dom";
import classnames from "classnames";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import DeleteModal from "../../../Components/Common/DeleteModal";
import ApproveModal from "../../../Components/Common/ApproveModal";
import { isEmpty, clone } from "lodash";
import { useTable, useGlobalFilter, useAsyncDebounce, useSortBy, useFilters, useExpanded, usePagination, useRowSelect } from "react-table";
import Flatpickr from "react-flatpickr";
import Select from "react-select";
// Formik
import * as Yup from "yup";
import { useFormik } from "formik";

//redux
import { useSelector, useDispatch } from "react-redux";

//Import actions
import { getBankBranch as onGetBankBranches, addNewBankBranch as onAddNewBankBranch, updateBankBranch as onUpdateBankBranch, deleteBankBranch as onDeleteBankBranch, getBankBranchLoading, resetBankBranchState } from "../../../store/bankBranch/action";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import defaultImg from "../../../assets/images/upload.png";
import imgNotFound from "../../../assets/images/users/img-remove.png";
import { api } from "../../../config";

const BankBranch = () => {
  const [activeTab, setActiveTab] = useState("1");
  const [activeTypeTab, setActiveTypeTab] = useState("all");
  const [companyName, setCompanyName] = useState({});
  const [company, setCompany] = useState("");
  const dispatch = useDispatch();

  const { clientSelected, companySelected, branchSelected, userData, userType, userRole, clients, clientLoading, bankBranches, isBankBranchCreated, isBankBranchSuccess, loading, error, companies, companyLoading } = useSelector((state) => ({
    clientSelected: state.App.clientSelected,
    companySelected: state.App.companySelected,
    branchSelected: state.App.branchSelected,
    userData: state.App.userData,
    userRole: state.App.userRole,
    userType: state.App.userType,
    bankBranches: state.BankBranch.bankBranches,
    isBankBranchCreated: state.BankBranch.isBankBranchCreated,
    isBankBranchSuccess: state.BankBranch.isBankBranchSuccess,
    loading: state.BankBranch.loading,
    clients: state.Client.clients,
    clientLoading: state.Client.loading,
    companies: state.Company.companies,
    companyLoading: state.Company.loading,
    error: state.BankBranch.error,
    attSchedules: state.AttSchedule.attSchedules,
    attScheduleLoading: state.AttSchedule.loading,
  }));

  const [bankBranchList, setBankBranchList] = useState([]);
  const [bankBranch, setBankBranch] = useState([]);
  const [info, setInfo] = useState([]);
  const [infoList, setInfoList] = useState([]);
  const [isExportCSV, setIsExportCSV] = useState(false);
  const [statusActive, setStatusActive] = useState([]);
  const [clientList, setClientList] = useState([]);
  const [companyList, setCompanyList] = useState([]);
  const [scheduleList, setScheduleList] = useState([]);
  const [componentList, setComponentList] = useState([]);
  const [approveModal, setApproveModal] = useState(false);

  const [positionMessage, setPositionMessage] = useState("");
  const [defaultCompanyId, setDefaultCompanyId] = useState(null);

  const statusActiveData = [
    {
      options: [
        { label: "DRAFT", value: "1" },
        { label: "ACTIVE", value: "2" },
        { label: "INACTIVE", value: "3" },
      ],
    },
  ];

  const dayName = [
    {
      options: [
        { label: "Sunday", value: "Sunday" },
        { label: "Monday", value: "Monday" },
        { label: "Tuesday", value: "Tuesday" },
        { label: "Wednesday", value: "Wednesday" },
        { label: "Thursday", value: "Thursday" },
        { label: "Friday", value: "Friday" },
        { label: "Saturday", value: "Saturday" },
      ],
    },
  ];

  const taxMethodData = [
    {
      options: [
        { label: "Tanpa Pajak", value: "No Tax" },
        { label: "Gaji Bersih", value: "Nett" },
        { label: "Gaji Kotor", value: "Gross" },
        { label: "Gross Up", value: "Gross Up" },
      ],
    },
  ];

  const [isSearch, setIsSearch] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [isEditDetail, setIsEditDetail] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteModalDetail, setDeleteModalDetail] = useState(false);
  const [deleteModalMulti, setDeleteModalMulti] = useState(false);

  const handleValidDate = (date) => {
    return moment(new Date(date), "YYYY/MM/DD").format("MMM D, YYYY");
  };

  const [filterDate, setFilterDate] = useState(null);

  const onClickDelete = (bankBranch) => {
    setBankBranch(bankBranch);
    setDeleteModal(true);
  };


  const handleDeleteBankBranch = () => {
    if (bankBranch) {
      dispatch(onDeleteBankBranch(bankBranch));
      setDeleteModal(false);
    }
  };

  const onClickApprove = (employee) => {
    setBankBranch(employee);
    setApproveModal(true);
  };

  useEffect(() => {
    setIsLoading(loading);
  }, [loading]);

  const toggleTab = (tab, type) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
      setActiveTypeTab(type);
      let filteredBankBranches = bankBranches;
      setBankBranchList(filteredBankBranches);
    }
  };

  useEffect(() => {
    if (companySelected && branchSelected) {
      dispatch(resetBankBranchState());
      dispatch(onGetBankBranches({ companyId: companySelected?.value ?? "", sales: true, branchId: branchSelected.value }));
    }
  }, [companySelected, branchSelected]);

  useEffect(() => {
    if (!isEmpty(bankBranches)) {
      setIsEdit(false);
      let filteredBankBranches = bankBranches;
      setBankBranchList(filteredBankBranches);
      setInfo(bankBranches[bankBranches.length - 1]);
      setInfoList(bankBranches[bankBranches.length - 1]?.bank_branch_sales);
    }
  }, [bankBranches]);

  useEffect(() => {
    var data = [];
    var opt = [];
    (companies || []).forEach((item, key) => {
      const name = item.name;
      const id = item.id;
      var obj = { label: name, value: id };
      opt.push(obj);
    });
    var option = { options: opt };
    data.push(option);

    if (companies.length > 0) {
      setCompanyList(data);
    }
  }, [companies]);

  useEffect(() => {
    if (!isEmpty(clients)) {
      var data = [];
      var opt = [];
      clients.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setClientList(data);
    }
  }, [clients]);

  const columns = useMemo(
    () => [
      {
        id: "#",
        Header: <input type="checkbox" id="checkBoxAll" className="form-check-input" onClick={() => checkedAll()} />,
        Cell: (cellProps) => {
          let data = cellProps.row.original;
          return (
            <div className="hstack gap-2 mt-4 mt-sm-0">
              <input type="checkbox" className="dataCheckbox form-check-input me-2" value={data.id} />
              <ButtonGroup className="me-1">
                <UncontrolledButtonDropdown>
                  <Button
                    color="light"
                    className="btn-sm"
                    onClick={() => {
                      setInfo(data);
                      setInfoList((data?.bank_branch_sales || []).filter(f => f.statusId !== 6));
                    }}
                  >
                    <i className="ri-eye-line fs-15"></i>
                  </Button>
                </UncontrolledButtonDropdown>
              </ButtonGroup>
            </div>
          );
        },
      },
      {
        Header: "Bank Pengajuan",
        accessor: "name",
        filterable: true,
      },
      {
        id: "Bank",
        Header: "Bank",
        accessor: "bank_branch_sales",
        filterable: true,
        Cell: (cell) => {
          const data = cell.row.original;
          return <span className="fw-semibold text-primary" onClick={() => {
            setInfo(data);
            setInfoList(data?.bank_branch_sales);
          }}>{(data?.bank_branch_sales || []).filter(f => f.bankBranchId === data.id && f.statusId !== 6 && f.statusDealId === 5).length}</span>
        },
      },
      {
        id: "SP3K",
        Header: "SP3K",
        accessor: "bank_branch_sales",
        filterable: true,
        Cell: (cell) => {
          const data = cell.row.original;
          return <span className="fw-semibold text-primary" onClick={() => {
            setInfo(data);
            setInfoList(data?.bank_branch_sales);
          }}>{(data?.bank_branch_sales || []).filter(f => f.bankBranchId === data.id && f.statusId !== 6 && f.statusDealId === 6).length}</span>
        },
      },
      {
        id: "FINAL_AKAD",
        Header: "Final/Akad",
        accessor: "bank_branch_sales",
        filterable: true,
        Cell: (cell) => {
          const data = cell.row.original;
          return <span className="fw-semibold text-primary" onClick={() => {
            setInfo(data);
            setInfoList(data?.bank_branch_sales);
          }}>{(data?.bank_branch_sales || []).filter(f => f.bankBranchId === data.id && f.statusId !== 6 &&  (f.statusDealId === 7 || f.statusDealId === 8)).length}</span>
        },
      },
      {
        Header: "Total Debitur",
        accessor: "bank_branch_sales",
        filterable: true,
        Cell: (cell) => {
          const data = cell.row.original;
          return <span className="fw-semibold text-primary" onClick={() => {
            setInfo(data);
            setInfoList(data?.bank_branch_sales);
          }}>{(data?.bank_branch_sales || []).filter(f => f.bankBranchId === data.id && f.statusId !== 6 ).length}</span>
        },
      },
      {
        Header: "Status",
        accessor: "bank_branch_status.name",
        filterable: true,
        Cell: (cell) => {
          switch (cell.row.original.statusId) {
            case 1:
              return <span className="badge text-uppercase badge-soft-warning">DRAFT</span>;
            case 2:
              return <span className="badge text-uppercase badge-soft-info">ACTIVE</span>;
            default:
              return <span className="badge text-uppercase badge-soft-danger">INACTIVE</span>;
          }
        },
      },
    ],
    [bankBranchList, userType, userRole]
  );

  const {
    getTableProps,
    rows,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    canPreviousPage,
    canNextPage,
    pageOptions,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    preGlobalFilteredRows,
    setGlobalFilter,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns: columns,
      data: bankBranchList,
      defaultColumn: { Filter: null },
      initialState: {
        pageIndex: 0,
        pageSize: 20,
        selectedRowIds: 0,
      },
    },
    useGlobalFilter,
    useFilters,
    useSortBy,
    useExpanded,
    usePagination,
    useRowSelect
  );

  const generateSortingIndicator = (column) => {
    return column.isSorted ? (column.isSortedDesc ? " " : "") : "";
  };

  const generateFilterable = (column) => {
    return column.filterable ? (column.isSorted ? (column.isSortedDesc ? " sorting_desc" : " sorting_asc") : " sort") : "";
  };

  const onChangeInSelect = (event) => {
    setPageSize(Number(event.target.value));
  };

  const onChangeInInput = (event) => {
    const page = event.target.value ? Number(event.target.value) - 1 : 0;
    gotoPage(page);
  };

  const count = preGlobalFilteredRows.length;
  const [searchValue, setSearchValue] = useState([]);
  const onChange = useAsyncDebounce((value) => {
    setGlobalFilter(value || undefined);
  }, 600);

  const handleApproveGroup = () => {
    if (bankBranch) {
      bankBranch.setApprove = true;
      dispatch(onUpdateBankBranch(bankBranch));
      setApproveModal(false);
    }
  };

  const checkedAll = () => {
    const checkall = document.getElementById("checkBoxAll");
    const ele = document.querySelectorAll(".dataCheckbox");

    if (checkall.checked) {
      ele.forEach((ele) => {
        ele.checked = true;
      });
    } else {
      ele.forEach((ele) => {
        ele.checked = false;
      });
    }
  };

  function handleBankBranchStatus(data) {
    setStatusActive(data);
  }

  function handleFilter() {
    let startat = "";
    let endat = "";
    let datearr = filterDate?.split(" to ");
    if (datearr) {
      startat = datearr[0];
      endat = datearr[1] ? datearr[1] : datearr[0];
    }
    var status = statusActive.value ? statusActive.value : "";
    const param = {
      title: searchValue,
      startat: startat,
      endat: endat,
      status: status,
      companyId: companySelected?.value ?? "",
    };
    dispatch(onGetBankBranches(param));
  }

  const handleResetFilter = () => {
    setFilterDate(null);
    setBankBranchList([]);
    setStatusActive([]);
    setSearchValue("");
    setGlobalFilter(undefined);
    dispatch(resetBankBranchState());
    dispatch(onGetBankBranches({ companyId: companySelected?.value ?? "" }));
  };

  const searchList = (e) => {
    let inputVal = e.toLowerCase();

    const filterItems = (arr, query) => {
      return arr.filter((el) => {
        return el.wgd_emp && el.wgd_emp.name && el.wgd_emp.name.toLowerCase().indexOf(query.toLowerCase()) !== -1;
      });
    };

    let filterData = filterItems(info.wg_detail, inputVal);
    setInfoList(filterData);
  };


  document.title = "Bank | Enterprise Resources Planning";
  return (
    <div className="page-content">
      <ApproveModal data={bankBranch && bankBranch.contract_employee ? bankBranch.contract_employee.name : ""} show={approveModal} onApproveClick={handleApproveGroup} onCloseClick={() => setApproveModal(false)} />
      <DeleteModal show={deleteModal} onDeleteClick={handleDeleteBankBranch} onCloseClick={() => setDeleteModal(false)} />
      <Container fluid>
        <BreadCrumb title="Penjualan" pageTitle="Bank Manajemen" loading={loading}>
          <div className="flex-shrink-0">
          </div>
        </BreadCrumb>
        <Row>
          <Col xxl={7}>
            <Card>
              <CardBody className="pt-0">
                <div>
                  <Row className="mb-3">
                    <CardBody className="border border-top-0 border-end-0 border-start-0">
                      <form>
                        <Row>
                          <Col sm={1}>
                            <div className="me-2 mb-2 col-12">
                              <select className="form-select" value={pageSize} onChange={onChangeInSelect}>
                                {[10, 25, 50, 100, 150, 250, 500, 1000, 2500, 5000].map((pageSize) => (
                                  <option key={pageSize} value={pageSize}>
                                    {pageSize}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </Col>
                          <Col sm={9}>
                            <div className="search-box me-2 mb-2 d-inline-block col-12">
                              <input
                                onChange={(e) => {
                                  setSearchValue(e.target.value);
                                  onChange(e.target.value);
                                  gotoPage(0);
                                }}
                                id="search-bar-0"
                                type="text"
                                className="form-control search"
                                placeholder={`${count} Cari...`}
                                value={searchValue ?? ""}
                              />
                              <i className="bx bx-search-alt search-icon"></i>
                            </div>
                          </Col>
                          <Col sm={2}>
                            <div className="hstack gap-2">
                              <button
                                type="button"
                                className="btn btn-icon btn-md btn-soft-success waves-effect waves-light material-shadow-none w-100"
                                onClick={() => {
                                  handleFilter();
                                }}
                              >
                                <i className="ri-search-line align-bottom fs-16"></i>
                              </button>
                              <button
                                type="button"
                                className="btn btn-icon btn-md btn-soft-info waves-effect waves-light material-shadow-none w-100"
                                onClick={() => {
                                  handleResetFilter();
                                }}
                              >
                                <i className="mdi mdi-restore align-bottom fs-18"></i>
                              </button>
                            </div>
                          </Col>
                        </Row>
                      </form>
                    </CardBody>
                  </Row>
                  <div className="table-responsive table-card mb-1">
                    <Table hover {...getTableProps()} className="align-middle table-nowrap">
                      <thead className="table-light">
                        {headerGroups.map((headerGroup, index) => (
                          <tr {...headerGroup.getHeaderGroupProps()} className={""} key={index}>
                            {headerGroup.headers.map((column, index) => (
                              <th key={index} className={"" + generateFilterable(column)} {...column.getSortByToggleProps()}>
                                {column.render("Header")}
                                {generateSortingIndicator(column)}
                                {/* <Filter column={column} /> */}
                              </th>
                            ))}
                          </tr>
                        ))}
                      </thead>

                      <tbody {...getTableBodyProps()}>
                        {page.map((row) => {
                          prepareRow(row);
                          return (
                            <Fragment key={row.getRowProps().key}>
                              <tr>
                                {row.cells.map((cell, index) => {
                                  return (
                                    <td {...cell.getCellProps()} key={index}>
                                      {cell.render("Cell")}
                                    </td>
                                  );
                                })}
                              </tr>
                            </Fragment>
                          );
                        })}
                      </tbody>
                    </Table>
                  </div>

                  <Row className="justify-content-md-end justify-content-center align-items-center p-2">
                    <Col className="col-md-auto d-none d-md-block">{rows.length} Data</Col>
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button color="light" onClick={previousPage} disabled={!canPreviousPage}>
                          {"<"}
                        </Button>
                      </div>
                    </Col>
                    <Col className="col-md-auto d-none d-md-block">
                      Halaman {pageIndex + 1} dari {pageOptions.length}
                    </Col>
                    <Col className="col-md-auto">
                      <Input type="number" min={1} style={{ width: 70 }} max={pageOptions.length} defaultValue={pageIndex + 1} onChange={onChangeInInput} />
                    </Col>
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button className="btn btn-light" onClick={nextPage} disabled={!canNextPage}>
                          {">"}
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </div>
              </CardBody>
            </Card>
          </Col>
          <Col xxl={5}>
            <Card>
              <div className="card-body d-flex align-items-center align-items-center">
                <h5 className="text-uppercase mb-2 flex-grow-1">{info.name ? info.name : " - "}</h5>
              </div>
              <CardBody>
                <div id="pagination-list">
                  <div className="mb-2 d-flex align-items-center">
                    <div className="flex-shrink-0 me-3 d-none">
                      <input type="checkbox" id="checkBoxAll" className="form-check-input" onClick={() => checkedAll()} />
                    </div>
                    <div className="flex-grow-1 overflow-hidden">
                      <input className="search form-control" placeholder="Cari..." onChange={(e) => searchList(e.target.value)} />
                    </div>
                  </div>
                  <SimpleBar style={{ height: "642px" }}>
                    <ListGroup className="list mb-0" flush>
                      {(infoList || []).sort((a, b) => a?.sales_customer?.name - b?.sales_customer?.name).map((row, idx) => {

                        let data = row;
                        let stat;
                        let statDeal;
                        let statName = data.sales_status && data.sales_status.name;
                        let statDealId = data.sales_deal_status && data.sales_deal_status.id;
                        switch (statDealId) {
                          case 3:
                            statDeal =
                              data.typeId === 3 || data.typeId === 4 ? (
                                <span className="badge text-uppercase" style={{ background: "#CFECF7", color: "#20A7DB" }}>
                                  CASH
                                </span>
                              ) : (
                                <span className="badge text-uppercase" style={{ background: "#ffe7ff", color: "#ea33f7" }}>
                                  {data.sales_deal_status.name}
                                </span>
                              );
                            break;
                          case 4:
                            statDeal = (
                              <span className="badge text-uppercase" style={{ background: "#ede3c5", color: "#806b29" }}>
                                {data.sales_deal_status.name}
                              </span>
                            );
                            break;
                          case 5:
                            statDeal = (
                              <span className="badge text-uppercase" style={{ background: "#EAFAEA", color: "#65B741" }}>
                                {data.sales_deal_status.name}
                              </span>
                            );
                            break;
                          case 6:
                            statDeal = (
                              <span className="badge text-uppercase" style={{ background: "#FFFBCA", color: "#F09319" }}>
                                {data.sales_deal_status.name}
                              </span>
                            );
                            break;
                          case 7:
                            statDeal = <span className="badge text-uppercase badge-soft-info">{data.sales_deal_status.name}</span>;
                            break;
                          case 8:
                            statDeal = (
                              <span className="badge text-uppercase" style={{ background: "#E8F9FF", color: "#2cc2c4" }}>
                                {data.sales_deal_status.name}
                              </span>
                            );
                            break;
                          default:
                            statDeal = "";
                            break;
                        }
                        switch (statName) {
                          case "DRAFT":
                            stat = <span className="badge text-uppercase badge-soft-warning">{statName}</span>;
                            break;
                          case "PENDING":
                            stat = <span className="badge text-uppercase badge-soft-secondary">{statName}</span>;
                            break;
                          case "CONFIRMED":
                            stat = <span className="badge text-uppercase badge-soft-info">{statName}</span>;
                            break;
                          case "PROCESSED":
                            stat = <span className="badge text-uppercase badge-soft-success">{statName}</span>;
                            break;
                          case "SHIPPED":
                            stat = <span className="badge text-uppercase badge-soft-primary">{statName}</span>;
                            break;
                          case "COMPLETED":
                            stat = <span className="badge text-uppercase badge-soft-success">{statName}</span>;
                            break;
                          default:
                            stat = <span className="badge text-uppercase badge-soft-danger">{statName}</span>;
                            break;
                        }

                        return (
                          <ListGroupItem className="ps-0 pe-0" key={row.id}>
                            <div className="d-flex align-items-center pagi-list">
                              <div className="flex-shrink-0 me-2 d-none">
                                <input type="checkbox" className="dataCheckbox form-check-input" value={row.id} />
                              </div>
                              <div className="flex-grow-1 overflow-hidden">
                                <div className="d-flex align-items-center">
                                  <div className="flex-shrink-0 me-2">
                                    {idx + 1}
                                  </div>
                                  <div className="flex-grow-1 ms-2 name">
                                    <h5 className="fs-14 text-primary mb-1">{row?.sales_customer?.name}</h5>
                                    <p className="born timestamp text-muted mb-0">{row?.sales_agent?.name} {statDeal}</p>
                                  </div>
                                </div>
                              </div>
                              <div className="flex-shrink-0 ms-2">
                                <div className="hstack gap-2 mt-4 mt-sm-0">
                                  {row?.sales_branch?.name} {stat}
                                </div>
                              </div>
                            </div>
                          </ListGroupItem>
                        );
                      })}
                      <ListGroupItem></ListGroupItem>
                    </ListGroup>
                  </SimpleBar>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default BankBranch;
